export const sortnum = ((col,order,list,setList,setOrder) => {
    if(order === "ASC"){
    const sorted = [...list].sort((a,b) =>
    parseInt(a[col]) > parseInt(b[col]) ? 1 : -1)
    setList(sorted);
    setOrder("DESC");
    }
    if(order === "DESC"){
        const sorted = [...list].sort((a,b) =>
        parseInt(a[col]) < parseInt(b[col]) ? 1 : -1)
        setList(sorted);
        setOrder("ASC");
        }
        })

 export const sortit = ((col,order,list,setList,setOrder,setWork) => {

     if(order === "ASC"){
            const sorted = [...list].sort((a,b) =>
            a[col] > b[col] ? 1 : -1)
            setList(sorted);
            setOrder("DESC");
            }
            if(order === "DESC"){
                const sorted = [...list].sort((a,b) =>
                a[col] < b[col] ? 1 : -1)
                setList(sorted);
                setOrder("ASC");
                }
              
                })

                export const sortdate = ((col,order,list,setList,setOrder) => {
                    if(order === "ASC"){
                           const sorted = [...list].sort((a,b) =>
                           Date.parse(a[col]) > Date.parse(b[col]) ? 1 : -1)
                           setList(sorted);
                           setOrder("DESC");
                           }
                           if(order === "DESC"){
                               const sorted = [...list].sort((a,b) =>
                               Date.parse(a[col]) < Date.parse(b[col]) ? 1 : -1)
                               setList(sorted);
                               setOrder("ASC");
                               }
                               })

                export const sortfollowdate = (col, order, list, setList, setOrder) => {
                    // Validate inputs
                    if (!Array.isArray(list) || !col || !setList || !setOrder) {
                      console.error('Invalid inputs:', { col, order, list, setList, setOrder });
                      return;
                    }
                  
                    // Log initial state
                    console.log('Sorting:', { col, order, listLength: list.length });
                  
                    // Create a sorted copy of the list
                    const sorted = [...list].sort((a, b) => {
                      const valueA = a[col]?.date;
                      const valueB = b[col]?.date;
                
                      // Handle null/undefined values
                      if (!valueA && !valueB) return 0; // Both null, maintain order
                      if (!valueA) return 1; // valueA is null, place after valueB
                      if (!valueB) return -1; // valueB is null, place before valueA
                  
                      // Parse dates, with error handling
                      let dateA, dateB;
                      try {
                        dateA = Date.parse(valueA);
                        dateB = Date.parse(valueB);
                      } catch (error) {
                        console.error('Date parsing error:', { valueA, valueB, error });
                        return 0; // Fallback to maintain order
                      }
                  
                      // Validate parsed dates
                      if (isNaN(dateA) || isNaN(dateB)) {
                        console.warn('Invalid dates:', { valueA, valueB, dateA, dateB });
                        return 0; // Fallback to maintain order
                      }
                  
                      // Sort based on order
                      return order === 'ASC' ? dateA - dateB : dateB - dateA;
                    });
                  
                    // Log sorted result
                    console.log('Sorted list:', sorted);
                  
                    // Update state
                    setList(sorted);
                    setOrder(order === 'ASC' ? 'DESC' : 'ASC');
                  };


                               export const sortnumbers = ((col,order,list) => {
                    
                            if(list){
                                if(order === "ASC"){
                                const sorted = [...list].sort((a,b) =>
                                parseInt(a[col]) > parseInt(b[col]) ? 1 : -1)
                                return sorted;
                               
                                }
                                if(order === "DESC"){
                                    const sorted = [...list].sort((a,b) =>
                                    parseInt(a[col]) < parseInt(b[col]) ? -1 : 1)
                                    return sorted;
                              
                                    }
                                }
                                    })


                                    export const sortshippingcustomer = ((col,order,list,setList,setOrder) => {
                                        console.log(list)
                                         if(order === "ASC"){
                                                const sorted = [...list].sort((a,b) =>
                                                a.customerid.name > b.customerid.name ? 1 : -1)
                                                setList(sorted);
                                                setOrder("DESC");
                                                }
                                                if(order === "DESC"){
                                                    const sorted = [...list].sort((a,b) =>
                                                        a.customerid.name < b.customerid.name ? 1 : -1)
                                                    setList(sorted);
                                                    setOrder("ASC");
                                                    }
                                                    })
                                                    export const sortshippingdescription = ((col,order,list,setList,setOrder) => {
                                                        console.log(list)
                                                         if(order === "ASC"){
                                                                const sorted = [...list].sort((a,b) =>
                                                                a.job.jobname > b.job.jobname ? 1 : -1)
                                                                setList(sorted);
                                                                setOrder("DESC");
                                                                }
                                                                if(order === "DESC"){
                                                                    const sorted = [...list].sort((a,b) =>
                                                                        a.job.jobname < b.job.jobname ? 1 : -1)
                                                                    setList(sorted);
                                                                    setOrder("ASC");
                                                                    }
                                                                    })

  export const sortsalesreps = ((col,order,list,setList,setOrder) => {
      console.log(list)
       if(order === "ASC"){
              const sorted = [...list].sort((a,b) =>
              a.salesrep?.firstName > b.salesrep?.firstName ? 1 : -1)
              setList(sorted);
              setOrder("DESC");
              }
              if(order === "DESC"){
                  const sorted = [...list].sort((a,b) =>
                      a.salesrep?.firstName < b.salesrep?.firstName ? 1 : -1)
                  setList(sorted);
                  setOrder("ASC");
                  }
                  })

                  export const sortcsrreps = ((col,order,list,setList,setOrder) => {
                    console.log(list)
                     if(order === "ASC"){
                            const sorted = [...list].sort((a,b) =>
                            a.custrep?.firstName > b.custrep?.firstName ? 1 : -1)
                            setList(sorted);
                            setOrder("DESC");
                            }
                            if(order === "DESC"){
                                const sorted = [...list].sort((a,b) =>
                                    a.custrep?.firstName < b.custrep?.firstName ? 1 : -1)
                                setList(sorted);
                                setOrder("ASC");
                                }
                                })